<template>
  <div>
    <ul class="nav nav-tabs  nav-tabs-line" role="tablist">
      <li v-for="(tab, index) in tabs" :key="index" :class="{ 'nav-item kt-tabs__item': true, 'active': tab.isActive }">
        <a :href="tab.href" role="tab"
           data-toggle="tab"
           :class="{'active': tab.isActive}" class="nav-link kt-tabs__link"
           @click="selectTab(tab)"><i :class="tab.$attrs.icon" />{{ tab.name }}</a>
      </li>
    </ul>
    <div class="tab-content">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    tabs: [],
  }),
  created() {
    // Assign all tab children to tabs object
    this.tabs = this.$children;
  },
  mounted() {
    // If there is a # in the URL make sure we load the correct tab
    this.selected_tab();
  },
  methods: {
    // When we click a tab give it an active state and deactive other tabs
    selectTab(selected_tab) {
      this.tabs.forEach((tab) => {
        if (tab.href === selected_tab.href) {
          window.location.hash = tab.href;
        }
        tab.isActive = tab.href === selected_tab.href;
      });
    },
    selected_tab() {
      // If there is a # in the URL make sure we load the correct tab
      const hash = self.document.location.hash.replace("#", "");
      if (hash.length) {
        this.tabs.forEach((tab) => {
          tab.isActive = tab.id === hash;
        });
      } else {
        // If no # make first tab active
        this.tabs[0].isActive = true;
      }
    },
  },
};
</script>
